// extracted by mini-css-extract-plugin
module.exports = {"Courses":"Courses_Courses__2pCAu","anim":"Courses_anim__342_G"};